module.exports = __webpack_public_path__ + "static/media/coin-1.51bbf733.png";